import { render, staticRenderFns } from "./top-home.vue?vue&type=template&id=18fcc694&scoped=true&"
import script from "./top-home.vue?vue&type=script&lang=js&"
export * from "./top-home.vue?vue&type=script&lang=js&"
import style0 from "./top-home.vue?vue&type=style&index=0&id=18fcc694&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18fcc694",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\mzkj\\要炼\\yl-pc-business\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18fcc694')) {
      api.createRecord('18fcc694', component.options)
    } else {
      api.reload('18fcc694', component.options)
    }
    module.hot.accept("./top-home.vue?vue&type=template&id=18fcc694&scoped=true&", function () {
      api.rerender('18fcc694', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/home/components/top-home.vue"
export default component.exports